import React from 'react'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'

import Layout from '../components/Layout/index'
import Section from '../components/Section/index'
import MainHeader from '../components/MainHeader/index'
import ColumnsGrid from '../components/ColumnsGrid/index'
import ArticleComponent from '../components/ArticleComponent/index'
import SocialMedia from '../components/SocialMedia/index'
import Quote from '../components/Quote/index'
import Banner from '../components/Banner/index'
import Video from '../components/Video/index'
import BlogList from '../components/BlogList/index'
import supporters from '../data/SupportersData'
import Button from '../components/Button/index'

const IndexPage = ({ data }) => {
  const {
    teema1,
    teema2,
    teema3,
    teema4,
    tarina1,
    tarina2,
    tarina3,
    posts,
    articles,
  } = data
  const blogPosts = posts.edges
    .map(({ node }) => ({
      id: node.id,
      title: node.title,
      date: node.date,
      link: `blogi/${node.title.replace(/ /gi, '-').replace(/,/gi, '')}`,
    }))
    .sort((a, b) => {
      return new Date(b.date) - new Date(a.date)
    })
    .slice(0, 3)

  const mediaArticles = articles.edges
    .map(({ node }) => ({
      media: node.name,
      title: node.title,
      date: node.date,
      link: node.link,
    }))
    .sort((a, b) => {
      return new Date(b.date) - new Date(a.date)
    })

  // const themes = [teema1, teema2, teema3, teema4]
  const stories = [tarina1, tarina2, tarina3]

  return (
    <Layout>
      {
        <>
          <Section variant="header">
            <MainHeader
              headingText="Kannustavampi yhteiskunta. Vapautta ja vastuuta."
              aboutText="Olen Daniel Rahman, 32-vuotias yrittäjä, ja olen ehdolla vuoden 2019 eduskuntavaaleissa Helsingin vaalipiirissä Kokoomuksen riveissä."
            />
          </Section>

          <Section variant="left" title="Teemat">
            <ColumnsGrid columns={2}>
              {/* {themes.map(article => (
                <ArticleComponent
                  key={article.title}
                  title={article.title}
                  content={article.body.childMarkdownRemark.html}
                  variantColor="black50"
                />
              ))} */}
              <ArticleComponent
                key="01"
                title="Neque porro quisquam"
                content="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut eget nunc leo. Fusce euismod elementum neque, ut sollicitudin tortor convallis aliquam. Sed pharetra est sed eleifend pulvinar. Donec quis ultrices turpis. Curabitur efficitur gravida justo, vel cursus tellus mollis iaculis. Aliquam vel erat orci. Morbi tincidunt leo eget venenatis aliquet."
                variantColor="black50"
              />
              <ArticleComponent
                key="02"
                title="Neque porro quisquam"
                content="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut eget nunc leo. Fusce euismod elementum neque, ut sollicitudin tortor convallis aliquam. Sed pharetra est sed eleifend pulvinar. Donec quis ultrices turpis. Curabitur efficitur gravida justo, vel cursus tellus mollis iaculis. Aliquam vel erat orci. Morbi tincidunt leo eget venenatis aliquet."
                variantColor="black50"
              />
              <ArticleComponent
                key="03"
                title="Neque porro quisquam"
                content="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut eget nunc leo. Fusce euismod elementum neque, ut sollicitudin tortor convallis aliquam. Sed pharetra est sed eleifend pulvinar. Donec quis ultrices turpis. Curabitur efficitur gravida justo, vel cursus tellus mollis iaculis. Aliquam vel erat orci. Morbi tincidunt leo eget venenatis aliquet."
                variantColor="black50"
              />
              <ArticleComponent
                key="04"
                title="Neque porro quisquam"
                content="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut eget nunc leo. Fusce euismod elementum neque, ut sollicitudin tortor convallis aliquam. Sed pharetra est sed eleifend pulvinar. Donec quis ultrices turpis. Curabitur efficitur gravida justo, vel cursus tellus mollis iaculis. Aliquam vel erat orci. Morbi tincidunt leo eget venenatis aliquet."
                variantColor="black50"
              />
            </ColumnsGrid>
          </Section>

          <Section variant="left" title="Blogista">
            <BlogList data={blogPosts} />
            <Button label="Katso kaikki" link="/blogi" position="right" />
          </Section>

          <Section variant="gray" title="Sosiaalinen media">
            <SocialMedia />
          </Section>

          <Section variant="image" title="Tarina">
            <ColumnsGrid>
              {stories.map(story => (
                <ArticleComponent
                  key={story.title}
                  title={story.title}
                  content={story.body.childMarkdownRemark.html}
                  variantColor="white50"
                />
              ))}
            </ColumnsGrid>
          </Section>

          <Section variant="title-description" title="Tukijat">
            <ColumnsGrid columns={2}>
              {supporters.slice(0, 4).map(quote => (
                <Quote
                  key={quote.author}
                  author={quote.author}
                  text={quote.text}
                  image={quote.image}
                  details={quote.details}
                />
              ))}
            </ColumnsGrid>

            <Button
              label="Katso kaikki"
              link="/tukijat"
              position="center-high"
            />
            <Banner
              title="Liity tukijoukkoihin"
              body="Haluatko olla osana ketterää vaalikampanjaa ja saada näköalapaikan politiikan juurille? Mukana voi olla monin eri tavoin joten älä epäröi ottaa yhteyttä!"
            />
          </Section>

          <Section variant="blue" title="Videot">
            <ColumnsGrid columns={3}>
              <Video youTubeVideoId="Y8aXVmcCPDU" />
              <Video youTubeVideoId="hvaIOSIqaNk" />
              <Video youTubeVideoId="9AoXFChxQHc" />
            </ColumnsGrid>
            <Button
              label="Katso kaikki"
              link="/videot"
              white
              position="center"
            />
          </Section>

          <Section variant="left" title="Mediassa">
            <BlogList data={mediaArticles} />
          </Section>
        </>
      }
    </Layout>
  )
}

export default IndexPage

IndexPage.propTypes = {
  data: PropTypes.objectOf(
    PropTypes.objectOf(PropTypes.any.isRequired).isRequired
  ).isRequired,
}

export const query = graphql`
  query {
    posts: allContentfulBlogPost {
      edges {
        node {
          id
          date
          title
        }
      }
    }
    articles: allContentfulArticle {
      edges {
        node {
          name
          title
          date
          link
        }
      }
    }
    teema1: contentfulTeema1 {
      title
      body {
        childMarkdownRemark {
          html
        }
      }
    }
    teema2: contentfulTeema2 {
      title
      body {
        childMarkdownRemark {
          html
        }
      }
    }
    teema3: contentfulTeema3 {
      title
      body {
        childMarkdownRemark {
          html
        }
      }
    }
    teema4: contentfulTeema4 {
      title
      body {
        childMarkdownRemark {
          html
        }
      }
    }
    tarina1: contentfulTarina1 {
      title
      body {
        childMarkdownRemark {
          html
        }
      }
    }
    tarina2: contentfulTarina2 {
      title
      body {
        childMarkdownRemark {
          html
        }
      }
    }
    tarina3: contentfulTarina3 {
      title
      body {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`
